// The module's single mount point. One line in AppShell renders both the strip
// that lives above every signed-in page and the drawer that opens over it.

import { ProgressStrip } from "./ProgressStrip";
import { GettingStarted } from "./GettingStarted";

export function Engagement() {
  return (
    <>
      <ProgressStrip />
      <GettingStarted />
    </>
  );
}
